import React from 'react'
import { Row, Col, Form, Alert } from 'antd'
import { Input, Radio, Button } from 'ui/styled'
import { Label } from 'pages/Ticket/styled'
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons'
import EnumSelect from 'components/EnumSelect'
import BenefitInquiryFieldsAttachment from './BenefitInuiryFieldsAttachment'

const { TextArea } = Input
const { Group } = Radio
const { Item, List } = Form

const radioOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false }
]

const BenefitInquiryFields = ({ form, resource }) => (
  <>
    <Row>
      <Col span={11}>
        <Label>Question</Label>
        <Item
          name="question"
          rules={[{ required: true, message: 'Add a question' }]}
        >
          <TextArea autoSize={{ minRows: 3, maxRows: 6 }} />
        </Item>
      </Col>
      <Col span={11} offset={1}>
        <Label>Topic Area</Label>
        <Item
          name="topic_area"
          rules={[{ required: true, message: 'Specify topic area' }]}
        >
          <EnumSelect
            enum_name="TOPIC_AREA"
            placeholder="Topic Area"
            data-test="benefitInquiryTopicAreaSelect"
          />
        </Item>
      </Col>
    </Row>
    <Row>
      {resource && (
        <Col span={11}>
          <Label>Configuration Change Required</Label>
          <Item name="config_change_required">
            <Group options={radioOptions} />
          </Item>
          <Alert
            type="warning"
            message="If Configuration Change is required create a Plan Change ticket"
            style={{ marginBottom: 10 }}
          />
        </Col>
      )}
      <Col span={11} offset={1}>
        <Label>Claim IDs</Label>
        <List name="claim_ids">
          {(fields, { add, remove }, { errors }) => (
            <>
              {fields.map((field, index) => (
                <Item key={field.key}>
                  <Row>
                    <Col span={16}>
                      <Item noStyle {...field}>
                        <Input placeholder="Claim ID" />
                      </Item>
                    </Col>
                    <Col span={7} offset={1}>
                      <Button
                        onClick={() => remove(field.name)}
                        icon={<MinusCircleOutlined />}
                      />
                    </Col>
                  </Row>
                </Item>
              ))}
              <Button
                style={{ marginBottom: 10 }}
                onClick={() => add()}
                icon={<PlusOutlined />}
              >
                Add field
              </Button>
              <Form.ErrorList errors={errors} />
            </>
          )}
        </List>
      </Col>
    </Row>
    <BenefitInquiryFieldsAttachment form={form} resource={resource} />
  </>
)

export default BenefitInquiryFields
